import { BRANDS, determineBrandFromURL } from '../helpers/brand';

/* GRADUAL TRANSITION OF BACKGROUND THEMES IN STAYCITY */
export const themeTransition = () => {
  const main = document.querySelector('main');
  const brand = determineBrandFromURL();

  /* Don't apply to WILDE */
  if (!main || brand === BRANDS.WILDE) {
    return;
  }

  /* Get first theme on the page */
  const intialTheme = main.querySelector<HTMLElement>('[data-theme]')?.getAttribute('data-theme');
  const disableScrollTheme = main.getAttribute('data-theme-no-scroll');

  if (!intialTheme) {
    return;
  }

  /* Set first applied theme in <main> so that it applys to the whole page */
  main.classList.add(intialTheme);
  main.setAttribute('active-theme', intialTheme!);

  window.addEventListener('scroll', () => {
    if (disableScrollTheme === 'true') return;

    const activeTheme = main.getAttribute('active-theme');

    /* Get scroll position. Divide by 3 so that it doesn't transition until the next secton is a little higher up the page */
    const scroll = window.scrollY + window.innerHeight / 3;

    main.querySelectorAll<HTMLElement>('[data-theme]').forEach((section) => {
      /* Themed section is currently in viewport */
      if (
        window.scrollY + section.getBoundingClientRect().top <= scroll &&
        window.scrollY + section.getBoundingClientRect().top + section.getBoundingClientRect().height > scroll
      ) {
        const newTheme = section.getAttribute('data-theme');

        /* Set new theme for page if it is different from the current theme */
        if (newTheme !== activeTheme) {
          for (let i = main.classList.length - 1; i >= 0; i--) {
            const className = main.classList[i];
            if (className.startsWith('staycity--')) {
              main.classList.remove(className);
            }
          }
          main.setAttribute('active-theme', newTheme!);
          main.classList.add(newTheme!);
        }
      }
    });
  });
};
